module.exports = __webpack_public_path__ + "static/media/speed.79e18c4e.svg";